// Routes
export const UNSUBSCRIBE_API_ROUTE = '/api/unsubscribe';
export const EKOMI_WIDGET_API_ROUTE = '/api/ekomi/component/';
export const EKOMI_TESTIMONIALS_API_ROUTE = '/api/ekomi/testimonials/';
